var _polygon, _polygon2, _rect, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#111111",
    viewBox: "0 0 340.38 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MINX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "35.03 89.02 52.05 62.95 52.05 143.33 69.07 143.33 69.07 0.67 35.03 55.71 1 0.67 1 143.33 18.02 143.33 18.02 62.95 35.03 89.02"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "232 143.33 193.54 75.5 193.54 143.33 176.52 143.33 176.52 0.67 215.1 73.33 215.1 0.67 232 0.67 232 143.33"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113.6,
    y: 0.67,
    width: 17.02,
    height: 142.65
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "307.55 93.12 323.72 143.33 339.89 143.33 315.51 66.33 336.51 0.67 319.62 0.67 307.55 37.84 295.48 0.67 278.58 0.67 299.58 66.33 275.2 143.33 291.38 143.33 307.55 93.12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinx);
export default __webpack_public_path__ + "static/media/minx.a0456d8aac6ddd2db4e813ae3aee48a7.svg";
export { ForwardRef as ReactComponent };